import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createSettingPriceFailed,
  createSettingPriceRequested,
  createSettingPriceSucceeded,
  updateSettingPriceFailed,
  updateSettingPriceRequested,
  updateSettingPriceSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createSettingPriceRequest(data) {
  yield put(createSettingPriceRequested(data));

  try {
    const { item } = yield call(request, api.createSettingPrice, data);

    const action = createSettingPriceSucceeded(item);

    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createSettingPriceFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateSettingPriceRequest(id, data) {
  yield put(updateSettingPriceRequested(id, data));

  try {
    const { item } = yield call(request, api.updateSettingPrice, id, data);

    const action = updateSettingPriceSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateSettingPriceFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
